import { render, staticRenderFns } from "./agreement-accepted.vue?vue&type=template&id=48f9ac8a"
import script from "./agreement-accepted.vue?vue&type=script&lang=js"
export * from "./agreement-accepted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports